import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Blog from "./pages/Blog";
import ArticlePage from "./pages/ArticlePage";
import Contacts from "./pages/Contacts";
import { Terminal as TerminalIcon, Menu, X } from "lucide-react";

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'HOME' },
    { path: '/about', label: 'ABOUT' },
    { path: '/projects', label: 'PROJECTS' },
    { path: '/blog', label: 'BLOG' },
    { path: '/contacts', label: 'CONTACTS' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {mobileMenuOpen && (
        <div 
          className="mobile-overlay"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
      <nav className="main-nav">
        <div className="nav-container">
          <Link to="/" className="nav-logo" onClick={() => setMobileMenuOpen(false)}>
            <TerminalIcon size={24} />
            <span className="logo-text">GT_</span>
          </Link>

          <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="nav-bracket">[</span>
                {item.label}
                <span className="nav-bracket">]</span>
              </Link>
            ))}
          </div>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>
    </>
  );
};

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-line">
          {'\u2500'.repeat(80)}
        </div>
        <div className="footer-text">
          <span className="text-cyan">&copy; 2025 Gabriele Tita</span>
          <span className="text-muted">|</span>
          <span className="text-muted">P.IVA 04200070235</span>
          <span className="text-muted">|</span>
          <span className="text-muted">Verona (VR), Italy</span>
        </div>
        <div className="footer-hint text-muted">
          # Built with React + Laravel | Secured by design
        </div>
      </div>
    </footer>
  );
};

function App() {
  return (
    <div className="App">
      <div className="scanlines"></div>
      <div className="crt-overlay"></div>
      
      <BrowserRouter>
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:articleId" element={<ArticlePage />} />
            <Route path="/contacts" element={<Contacts />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
